import componentFn from '../../styles/objects/component'
import breakTo from '../../styles/tools/breakTo'
import { important } from '../../styles/tools/parsers'

export default ({
  colors,
  spacings,
  images,
  fontFamilies,
  fontWeights,
  fontSizes,
  textTransforms
}) => {
  const component = componentFn({
    colors,
    spacings,
    images,
    fontFamilies,
    fontWeights,
    fontSizes,
    textTransforms
  })

  const styles = {
    radio: { width: '50% !important' },

    'radio--image': {
      cursor: 'pointer',
      paddingTop: important('6.6rem'),

      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'top center'
    },

    'radio--readonly': {
      cursor: 'default'
    },

    label: {
      fontFamily: fontFamilies.alternate
    },

    'label--image': {
      fontWeight: fontWeights.radio.title,

      position: important('static'),

      display: important('block'),

      width: important('100%'),
      marginRight: 'auto',
      marginLeft: 'auto',
      paddingTop: '2.5rem',
      paddingLeft: important('0'),

      textAlign: 'center',

      '::before': {
        top: important('7rem'),
        left: important('50%'),

        marginLeft: '-10px'
      },

      '::after': {
        top: important('7.4rem'),
        left: important('50%'),

        marginLeft: '-4px'
      }
    },

    'radio--phisical-card': {
      backgroundImage: images.phisicalCard
    },

    'radio--phisical-card-selected': {
      backgroundImage: images.phisicalCardSelected
    },

    'radio--virtual-card': {
      backgroundImage: images.virtualCard,

      [breakTo('small')]: {
        backgroundPositionX: spacings.radioImage.virtualCard.small
      }
    },

    'radio--virtual-card-selected': {
      backgroundImage: images.virtualCardSelected,

      [breakTo('small')]: {
        backgroundPositionX: spacings.radioImage.virtualCard.small
      }
    },

    'radio--selfie': {
      backgroundImage: images.selfie,
      backgroundPositionX: spacings.radioImage.selfie.default,

      backgroundSize: 100,

      [breakTo('small')]: {
        backgroundPositionX: spacings.radioImage.selfie.small
      }
    },

    'radio--selfie-selected': {
      backgroundImage: images.selfieSelected,
      backgroundPositionX: spacings.radioImage.selfie.default,

      backgroundSize: 100,

      [breakTo('small')]: {
        backgroundPositionX: spacings.radioImage.selfie.small
      }
    },

    'radio--bonifico': {
      backgroundImage: images.bonifico
    },

    'radio--bonifico-selected': {
      backgroundImage: images.bonificoSelected
    },

    input: {
      position: 'absolute',
      left: '-9999px',

      ':enabled + label': {
        fontSize: '0.875rem',
        lineHeight: '1.8',

        position: 'absolute',

        display: 'inline-block',

        paddingLeft: spacings.x5,

        cursor: 'pointer',

        color: colors.common.text,
        // checkbox appearence
        '::before': {
          position: 'absolute',
          top: '0',
          left: '0',

          width: '20px',
          height: '20px',

          content: "''",

          border: `2px solid ${colors.flag.default}`,
          borderRadius: '50%',
          background: colors.flag.bg
        },
        // checked mark appearence
        '::after': {
          fontSize: spacings.x4,
          lineHeight: '15px',

          position: 'absolute',
          top: '6px',
          left: '6px',

          width: '10px',
          height: '10px',

          content: "''",
          transition: 'all .2s',
          textAlign: 'center',

          border: `1px solid ${colors.flag.checked}`,
          borderRadius: '50%',
          backgroundColor: colors.flag.checked
        }
      },

      ':disabled + label': {
        color: colors.flag.default
      },

      ':not(:checked) + label::after': {
        fontSize: 0,

        opacity: 0
      },

      ':not(:checked):disabled + label::before': {
        boxShadow: 'none'
      },

      ':checked + label::before': {
        border: `2px solid ${colors.flag.checked}`
      },

      ':checked + label::after': {
        transform: 'scale(1)',

        opacity: '1'
      },

      ':disabled + label::before': {
        boxShadow: 'none'
      },

      ':disabled + label::after': {
        border: `1px solid ${colors.flag.disabled}`
      }
    },

    'input--image': {
      ':not(:checked) + label': {
        color: colors.flag.default
      }
    },

    'label--invalid': {
      color: colors.common.utility.error.default
    },

    sublabel: {
      fontSize: '13px',
      fontWeight: fontWeights.radio.subtitle,
      lineHeight: '1rem'
    },
    'sublabel--readonly': {
      color: colors.common.text,
      cursor: 'text'
    },
    'radio--input-height':{
      'min-height': '7rem'
    }
  }

  return { ...component, ...styles }
}



// WEBPACK FOOTER //
// ./components/radio/styles.js